import React from "react";

const Button = ({btnType, btnTxtContent, btnClassName, onClick, ...props}) => {

    return(
        <button type={btnType} className={btnClassName} onClick={onClick} {...props}>{btnTxtContent}</button>
    );
};

export default Button;